export const getQuarter = () => {
  const thisMonth = new Date().getMonth();
  return thisMonth % 3;
};

export const SHORTCUTSCONFIG = [
  { startRelativeDate: 0, endRelativeDate: 0, label: '今天' },
  { startRelativeDate: -1, endRelativeDate: -1, label: '昨天' },
  { startRelativeDate: -6, endRelativeDate: 0, label: '最近7天' },
  { startRelativeMonth: 0, endRelativeMonth: 0, label: '本月' },
  { startRelativeDate: -29, endRelativeDate: 0, label: '最近30天' },
  { startRelativeMonth: -getQuarter(), endRelativeMonth: 0, label: '本季度' },
];

export const SHORTCUTSCONFIG2 = [
  { startRelativeDate: 0, endRelativeDate: 0, label: '今天' },
  { startRelativeDate: -1, endRelativeDate: -1, label: '昨天' },
  { startRelativeDate: -7, endRelativeDate: -1, label: '最近7天' },
  { startRelativeMonth: 0, endRelativeMonth: 0, endRelativeDate: -1, label: '本月' },
  { startRelativeDate: -30, endRelativeDate: -1, label: '最近30天' },
  { startRelativeMonth: -getQuarter(), endRelativeMonth: 0, endRelativeDate: -1, label: '本季度' },
];

// 获取当前季度开始结束日期
export const getQuarterDate = (thisStartDate) => {
  const thisYear = thisStartDate.split('-')[0];
  const date = thisStartDate.split('-')[1];
  const nowDate = getDay(-1, '-');
  const nowMonth = Number(nowDate.split('-')[1]);
  let startDate = '';
  let endDate = '';
  const Q1 = 1;
  const Q2 = 4;
  const Q3 = 7;
  const Q4 = 10;
  if (Number(date) > Q1 || Number(date) == Q1) {
    startDate = `${thisYear}-01-01`;
    endDate = `${thisYear}-03-31`;
  }
  if (Number(date) > Q2 || Number(date) == Q2) {
    startDate = `${thisYear}-04-01`;
    endDate = `${thisYear}-06-30`;
  }
  if (Number(date) > Q3 || Number(date) == Q3) {
    startDate = `${thisYear}-07-01`;
    endDate = `${thisYear}-09-30`;
  }
  if (Number(date) > Q4 || Number(date) == Q4) {
    startDate = `${thisYear}-10-01`;
    endDate = `${thisYear}-12-31`;
  }

  if (new Date(endDate).getTime() > new Date(nowDate).getTime()) {
    endDate = nowDate;
  }
  return {
    startDate,
    endDate,
  };
};
export const getDay = (num, str) => {
  const today = new Date();
  const nowTime = today.getTime();
  const ms = 24 * 3600 * 1000 * num;
  today.setTime(parseInt(nowTime + ms));
  const oYear = today.getFullYear();
  let oMoth = (today.getMonth() + 1).toString();
  if (oMoth.length <= 1) oMoth = `0${oMoth}`;
  let oDay = today.getDate().toString();
  if (oDay.length <= 1) oDay = `0${oDay}`;
  return oYear + str + oMoth + str + oDay;
};

// 生成季度下拉的方法
function quarterSelectConfig(beginTime) {
  const thisYear = new Date().getFullYear();
  const lastYear = thisYear - 1;
  const thisMonth = new Date().getMonth() + 1;
  const quarterArr = [1, 4, 7, 10];
  const quarter = [
    { start: '01-01', end: '03-31' },
    { start: '04-01', end: '06-30' },
    { start: '07-01', end: '09-30' },
    { start: '10-01', end: '12-31' },
  ];
  let result = [];
  let resultM = [];
  let resultData = [];
  const thisYearQuarterArr = [];
  const lastYearQuarterArr = [];
  const thisYearMArr = [];
  const lastYearMArr = [];
  quarterArr.forEach((item, index) => {
    const currentQuarter = quarter[index];
    ++index;
    if (thisMonth >= item) {
      thisYearQuarterArr.unshift({ label: `${thisYear}Q${index}`, value: `${thisYear}Q${index}`, date: {
        year: thisYear,
        startDate: `${thisYear}-${currentQuarter.start}`,
        endDate: `${thisYear}-${currentQuarter.end}`,
      } });
      thisYearMArr.unshift({ label: `${thisYear}Q${index}-${item}`, value: `${thisYear}M${item}` });
      thisYearMArr.unshift({ label: `${thisYear}Q${index}-${item + 1}`, value: `${thisYear}M${item + 1}` });
      thisYearMArr.unshift({ label: `${thisYear}Q${index}-${item + 2}`, value: `${thisYear}M${item + 2}` });
    } else {
      lastYearQuarterArr.unshift({ label: `${lastYear}Q${index}`, value: `${lastYear}Q${index}`, date: {
        year: lastYear,
        startDate: `${lastYear}-${currentQuarter.start}`,
        endDate: `${lastYear}-${currentQuarter.end}`,
      } });
      lastYearMArr.unshift({ label: `${lastYear}Q${index}-${item}`, value: `${lastYear}M${item}` });
      lastYearMArr.unshift({ label: `${lastYear}Q${index}-${item + 1}`, value: `${lastYear}M${item + 1}` });
      lastYearMArr.unshift({ label: `${lastYear}Q${index}-${item + 2}`, value: `${lastYear}M${item + 2}` });
    }
  });
  result = [...thisYearQuarterArr, ...lastYearQuarterArr];
  resultM = [...thisYearMArr, ...lastYearMArr];

  if (beginTime) {
    resultData = result.filter((item) => {
      const {
        endDate,
      } = item.date;
      return new Date(endDate).getTime() >= new Date(beginTime).getTime();
    });
  }
  return { result, resultM, resultData };
}

export const quarterConfig = quarterSelectConfig();
export const getQuarterConfig = quarterSelectConfig;

function getQueryData() {
  const data = [
    {
      value: 'Q',
      desc: '按季度',
      parent_id: '',
      options: [],
    },
    {
      value: 'M',
      desc: '按月份',
      parent_id: '',
      options: [],
    },
  ];
  quarterConfig.result.forEach((x) => {
    data.forEach((y) => {
      if (y.value == 'Q') {
        const obj = {
          value: x.value,
          desc: x.label,
          parent_id: 'Q',
        };
        y.options.push(obj);
      }
    });
  });
  quarterConfig.resultM.forEach((x) => {
    data.forEach((y) => {
      if (y.value == 'M') {
        const obj = {
          value: x.value,
          desc: x.label,
          parent_id: 'M',
        };
        y.options.push(obj);
      }
    });
  });
  return data;
}
export const queryData = getQueryData();

export const rptSearchDimension = {
  AGENCY_UID: {
    label: ' 广告平台',
    value: 'AGENCY_UID',
    name: 'agency_uid',
  },
  PARENT_ID: {
    label: '一级行业',
    value: 'INDUSTRY_PARENT_ID',
    name: 'industry_parent_name',
  },
  INDUSTRY_ID: {
    label: '二级行业',
    value: 'INDUSTRY_ID',
    name: 'industry_name',
  },
  MANAGER: {
    label: '主要运营人员',
    value: 'MANAGER',
    name: 'qq_number',
  },
};

export default {
  SHORTCUTSCONFIG,
  getQuarterDate,
  getDay,
  quarterConfig,
  rptSearchDimension,
};
